import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const CompanyNote = React.lazy(() =>
    import('../CompanyNote')
);
const companyNoteRoutesRegistry = [
    {
        path: PAGE_URL.COMPANY_NOTE_PAGE,
        element: <CompanyNote />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default companyNoteRoutesRegistry;
